var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.17 129.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.01,69.3v2.34c-.03-.3-.05-.61-.05-.92-.01-.48.01-.95.05-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35.61,93.03c-.84.11-1.69.17-2.55.18-5.1.07-9.84-1.53-13.66-4.29-.48-.35-.95-.71-1.4-1.09.04-.03.08-.05.12-.07,4.36,3.56,9.78,5.46,15.49,5.38.67-.01,1.34-.04,2-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.47,63.61c0,9.62,7.83,17.45,17.45,17.45h53.25v21.29c0,4.85-3.95,8.81-8.81,8.81h-75.52c-2.74-12.85-11.02-23.92-22.75-30.17,1.76-3.29,2.74-7.06,2.68-11.06-.18-12.7-10.6-22.85-23.29-22.69-6.48.08-12.31,2.84-16.43,7.22l.11-38.01c1.76,1.15,4.21,1.7,7.57,1.92h127.63c4.86,0,8.81,3.95,8.81,8.81v18.99h-53.25c-9.62,0-17.45,7.83-17.45,17.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.96,70.72c0,.31.02.62.04.92v-2.34c-.03.47-.05.94-.04,1.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.18,5.21v8.64H24.55c-3.85,0-7.11-2.53-8.23-6-.27-.84-.41-1.72-.41-2.64,0-.27.02-.55.07-.81.38-2.49,2.54-4.4,5.14-4.4h110.85c2.87,0,5.21,2.34,5.21,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.17,51.12v24.52h-51.38c-7.16,0-12.98-5.5-12.98-12.26s5.82-12.25,12.98-12.25h51.38Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.94,117.69c0,.28,0,.56,0,.84C49.13,135.46,9.64,129.65,0,119.05v-.49c-.14-10.3,4.36-19.98,11.94-26.53.64-.57,1.32-1.11,2.01-1.61.65-.49,1.31-.95,2-1.38.66-.43,1.35-.83,2.05-1.21.45.38.92.74,1.4,1.09,3.82,2.76,8.56,4.36,13.66,4.29.86-.01,1.71-.07,2.55-.18.12-.01.25-.02.37-.04,4.96-.55,9.65-2.66,13.36-5.98,9.82,4.7,16.75,13.68,18.88,24.15.15.66.26,1.33.36,2,.09.66.17,1.33.22,2,.08.83.12,1.67.13,2.52h0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.7,70.28c.06,3.51-.98,6.79-2.78,9.49-.99,1.51-2.21,2.84-3.63,3.95-2.82,2.25-6.38,3.6-10.25,3.64-3.74.06-7.22-1.12-10.03-3.15-1.71-1.23-3.17-2.75-4.32-4.53-1.54-2.34-2.5-5.08-2.69-8.04v-2.34c.6-8.67,7.78-15.57,16.61-15.68,9.31-.11,16.97,7.33,17.09,16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.01,69.3v2.34c-.03-.3-.05-.61-.05-.92-.01-.48.01-.95.05-1.42Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWallet);
export default __webpack_public_path__ + "static/media/UsersWallet.b68433184dc262cb0e7e10718f039f41.svg";
export { ForwardRef as ReactComponent };